import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { Component, OnInit } from '@angular/core';
import { initializedSalesOpportunitySearchDto } from 'src/app/sales-opportunities/shared/dto/sales-opportunity-search.dto';
import { SalesOpportunityDto } from 'src/app/sales-opportunities/shared/dto/sales-opportunity.dto';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';
import { UserService } from 'src/app/users/shared/user.service';

@Component({
  selector: 'wl-profile-sales-opportunities',
  templateUrl: './profile-sales-opportunities.component.html',
  styleUrls: ['./profile-sales-opportunities.component.less'],
    standalone: false
})
export class ProfileSalesOpportunitiesComponent implements OnInit {
  searchParams = this.initializedParams();
  salesOpportunitySearchResult: PagedResultGeneric<SalesOpportunityDto>;
  profileModuleFullAccess: boolean = false;
  profileContactsTabFullAccess: boolean = false;

  constructor(private _userService: UserService) {}

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;

      if (this.profileModuleFullAccess) {
        this._userService.getCurrentUserSecurityElementAccessLevel('ProfileContacts_Tab').then((userAccessLevel: number) => {
          this.profileContactsTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
        });
      }
    });
  }

  clear() {
    this.searchParams = this.initializedParams();
  }

  private initializedParams() {
    const searchDto = initializedSalesOpportunitySearchDto();
    searchDto.IncludeRevenueItem = true;
    searchDto.IncludeProfile = true;
    searchDto.IncludeProbability = true;
    return searchDto;
  }
}
